exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td{\r\n    vertical-align: middle;\r\n}\r\n\r\nth{\r\n    text-align: center;\r\n}\r\n\r\n.hidden{\r\n    display:none;\r\n}\r\n\r\n.f-10{\r\n    font-size:8px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/media/media.component.css
// module id = ../../../../../src/app/media/media.component.css
// module chunks = main